// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"11":"component---src-templates-project-tsx","245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"11":"c579b80e480ec673d932","245":"9055586690bedf896734","453":"e46edc5de6917cc4c8f5"}[chunkId] + ".js";
};